export const DEAL_TYPES = {
  channelManager: 'channelManager',
  default: 'default',
};
